module.exports = __webpack_public_path__ + "static/media/view2.dd3f9ee8.jpg";